import { Component, OnInit, ViewChild } from '@angular/core';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'projects/services/src/app/API/user.service'
import { FileService } from 'projects/services/src/app/API/document/file.service';
import { TotToaDataFilterComponent } from '../tot-toa-data-filter/tot-toa-data-filter.component';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeographiesService } from 'projects/services/src/app/API/geographies.service';
import { AssessmentAgencyService } from 'projects/services/src/app/API/assessment-agency.service';
import { TrainingCentersService as TrainingCentreAPI } from 'projects/services/src/app/API/training-centers.service';
import * as _ from 'lodash';
import { BatchService } from 'projects/services/src/app/API/batch.service';
import { MasterTrainerService } from 'projects/services/src/app/API/master-trainer.service';
declare var $: any;
declare var toastr: any;
declare const swal: any;

@Component({
	selector: 'app-applicant-certification-list',
	templateUrl: './applicant-certification-list.component.html',
	styleUrls: ['./applicant-certification-list.component.css']
})
export class ApplicantCertificationListComponent implements OnInit {
	@ViewChild('filters') filters: TotToaDataFilterComponent;

	currentStep: any = 1;
	totalCertificates: any[] = [];
	remarks = [];
	pageNo = 1;
	perPage = 10;
	filterData: {};
	status: any;
	count: number;
	currentCertificate: any;
	certificateFileName: any;
	fileName: any;
	currentUser: any;
	activeTab = 'pending';
	customFilterFields = {
		'userType': true,
		'sector': true,
		'jobRoles': true,
		'state': true,
		'typeOfCertification': true
	}

	certificateFeedback: any;
	feedBackForm: FormGroup;
	isFeedback: Boolean = false;
	selectedCertificate: any;
	assessorType = 'masterAssessor'

	trainingCentreSearchForm: FormGroup;
	masterTrainerSearchForm: FormGroup;
	assessorSearchForm: FormGroup;

	filterPageNo = 1;
	filterPerPage = 10;

	states: any;
	selState: any;
	districts: any;
	selDistrict: any;
	stateStatus = false;
	districtStatus = false;

	stateDropDownData: any = [];
	districtDropDownData: any = [];
	selectedItemsDistrict: any = [];
	selectedItemsState: any = [];

	settings = {
		singleSelection: true,
		text: 'Select a type',
		enableSearchFilter: true,
		showCheckbox: false,
		disabled: false
	};

	assessors: any;
	assessorLength: any;
	isAssessor: Boolean = true;
	assessorIndex: Boolean = true;
	selectedAssessor: any;

	masterTrainers = [];
	selectedTrainer: any;
	trainerIndex: any;
	trainerLength: any;
	isTrainer: Boolean = true;

	searchTCPopup: string;

	pageNoTab_1 = 1
	pageNoTab_2 = 1
	itemsPerPageTab_1 = 10
	itemsPerPageTab_2 = 10

	allTcTab = true;
	previouslyConductedTcTab = false;

	trainingCentres = [];
	previouslyConductedTrainingCentres = [];
	tcId: any;
	selectedItemsTrainingCentreType = [];

	lengthTab_1: any;
	lengthTab_2: any;

	isTrainingCenter: Boolean = true
	tcIndex = false;
	selectedTC: any;

	isFeedbackAvailable = false;
	feedbackProvided: any;

	todayDate = new Date();

	isTrainerFeedback = false;
	isFeedbackForAssessor = false;
	isTCFeedback = false;

	trainingCentreTypeDropdownData = [{
		id: 1, itemName: 'General',
	}, {
		id: 2, itemName: 'Exclusive'
	}];

	constructor(
		private currentUserService: CurrentUserService,
		private router: Router,
		private userService: UserService,
		private activatedRoute: ActivatedRoute,
		private fileDownload: FileService,
		private _formBuilder: FormBuilder,
		private geographiesService: GeographiesService,
		private assesmentAgencyService: AssessmentAgencyService,
		private masterTrainerService: MasterTrainerService,
		private trainingCentreAPI: TrainingCentreAPI,
		private _batchService: BatchService
	) { }

	ngOnInit() {
		this.createSearchTrainingCentreForm();
		this.createAssessorSearchForm();
		this.createMasterTrainerSearchForm();
		this.getStates();
		this.currentUser = this.currentUserService.decodeToken();
		this.getCerificateList('Pending');
		this.status = 'Pending';
	}

	changeCurrentStep(step: string) {
		if (step === 'notApproved') {
			this.currentStep = 1;
			this.status = 'Pending';
			this.activeTab = 'pending';
			this.getCerificateList('Pending');
		} else if (step === 'approved') {
			this.currentStep = 2;
			this.activeTab = step;
			this.status = 'Approved';
			this.getCerificateList('Approved');
		} else if (step === 'rejected') {
			this.currentStep = 3;
			this.activeTab = step;
			this.status = 'Rejected';
			this.getCerificateList('Rejected');
		}
	}

	getCerificateList(displayTab) {
		this.totalCertificates = [];
		// API CALL to get List Data;
		this.userService.getCertificatesAddedForApprovales(this.pageNo, this.perPage, displayTab, this.filterData).subscribe(res => {
			this.totalCertificates = res.data;
			this.count = res.count;
			console.log('certificate List', res);
		}, err => {
			toastr.error('No Batches Found');
		});
	}

	getRemarks(data) {
		this.remarks = [];
		this.remarks = data.bySSC;
	}

	editJobRole(batch) {
		console.log(batch);
		let type;
		if (this.currentStep === 1) {
			type = 'Request';
		}
		else if (this.currentStep === 2) {
			type = 'Approved';
		}
		else if (this.currentStep === 3) {
			type = 'Rejected';
		}
		if (type === 'Rejected' && batch.certificateDetails.typeOfCertification === 'Advanced') {
			this.applyForAdvanceCertificate(batch);
		} else {
			this.router.navigate(['../applicat-add-certificate'], {
				queryParams: {
					jobRoleId: batch.jobRoleId, tabType: type,
					applicantId: batch.userName, batchType: batch.batchType.name, reqId: batch.certReqId, userType: batch.certificateDetails.certificateType
				},
				relativeTo: this.activatedRoute
			})
		}
	}

	addCertification() {
		// swal({
		// 	type: 'info',
		// 	text: 'You should enroll for a batch on the training calendar in order to get a certification for the program.'
		// })
		// return;
		this.router.navigate(['../applicat-add-certificate'], {
			relativeTo: this.activatedRoute
		})
	}

	advanceCertificate(tab) {
		this.activeTab = tab;
		this.changeCurrentStep(tab);
	}

	downloadCertificate(certificate) {
		if (certificate.certificateDetails.feedback) {
			if (certificate.certificateDetails.certificateURLDetails.key) {
				this.fileDownload.downloadAttachedFile(certificate.certificateDetails.certificateURLDetails.key);
			} else {
				this.fileDownload.downloadAttachedFile(certificate.certificateDetails.certificateURLDetails.location);
			}
		} else {
			swal({
				title: `To download certificate, you need to provide feedback. Do you want to Proceed?`,
				type: 'info',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				cancelButtonColor: '#d33',
			}).then((action: any) => {
				if (action.value) {
					this.provideFeedback(certificate);
					Helpers.openModal('provide_feedback_modal');
				}
			})
		}
		console.log(certificate);

	}

	viewCertificateDetails(certificate) {
		this.currentCertificate = certificate;
		if (this.currentCertificate.certificateDetails && this.currentCertificate.certificateDetails.certificateURLDetails &&
			this.currentCertificate.certificateDetails.certificateURLDetails.key) {
			const certificateFile = this.currentCertificate.certificateDetails.certificateURLDetails.key;
			const splitCertificateFile = certificateFile.split('/');
			this.certificateFileName = splitCertificateFile.pop();
		} else if (this.currentCertificate.certificateDetails && this.currentCertificate.certificateDetails.certificateURLDetails &&
			this.currentCertificate.certificateDetails.certificateURLDetails.location) {
			const certificateFile = this.currentCertificate.certificateDetails.certificateURLDetails.location;
			const splitCertificateFile = certificateFile.split('/');
			this.certificateFileName = splitCertificateFile.pop();
		}
		if (this.currentCertificate.certificateDetails && this.currentCertificate.certificateDetails.supportingDocumentURLDetails &&
			this.currentCertificate.certificateDetails.supportingDocumentURLDetails.location) {
			const file = this.currentCertificate.certificateDetails.supportingDocumentURLDetails.location;
			const splitFile = file.split('/');
			this.fileName = splitFile.pop();
		} else if (this.currentCertificate.certificateDetails && this.currentCertificate.certificateDetails.certificateURLDetails &&
			this.currentCertificate.certificateDetails.certificateURLDetails.location) {
			const certificateFile = this.currentCertificate.certificateDetails.certificateURLDetails.location;
			const splitCertificateFile = certificateFile.split('/');
			this.certificateFileName = splitCertificateFile.pop();
		}
		console.log(certificate);
		Helpers.openModal("m_modal_2");
	}

	DownloadFile(document) {
		console.log(document);
		if (document.key !== '') {
			this.fileDownload.downloadAttachedFile(document.key);
		} else {
			this.fileDownload.downloadAttachedFile(document.location);
		}

	}

	getFilterData(event) {
		console.log(event);
		this.pageNo = 1;
		this.filterData = event;
		this.totalCertificates = [];
		this.getCerificateList(this.status);
	}

	getPerPage(event) {
		this.perPage = event;
		this.getCerificateList(this.status);
	}

	getPageNo(event) {
		this.pageNo = event;
		this.getCerificateList(this.status);
	}

	resetFilter() {
		this.pageNo = 1;
		this.perPage = 10;
		console.log(this.status);
		this.totalCertificates = [];
		this.filterData = [];
		this.getCerificateList(this.status);
	}
	resetSearch() {
		this.filters.reset();
	}
	assignPageNo(pageNo) {
		this.pageNo = pageNo;
		this.getCerificateList(this.status);
	}
	assignPerPage(perPage) {
		this.perPage = perPage;
		this.getCerificateList(this.status);
	}

	applyForAdvanceCertificate(certificate) {
		const displayTab = 'Other'
		this.filterData = {
			'sector': certificate.sector.id,
			'jobRole': certificate.jobRoleId,
			'typeOfCertification': certificate.certificateDetails.typeOfCertification ? certificate.certificateDetails.typeOfCertification : 'Advanced'
		}
		this.userService.getCertificatesAddedForApprovales(this.pageNo, this.perPage, displayTab, this.filterData).subscribe(res => {
			if (res.data !== null) {
				toastr.error('Certification request already exists');
			} else {
				if (this.currentUser.role === 'Trainer') {
					this.router.navigate(['trainer/applicant/applicant-advance-certificate'], {
						queryParams: {
							tab: this.status,
							userName: certificate.userName,
							batchType: certificate.batchType.name,
							certReqId: certificate.certReqId,
							qpCode: certificate.jobRoleId,
							sectorId: certificate.sector.id
						}
					});
				} else if (this.currentUser.role === 'Assessor') {
					this.router.navigate(['assessor/applicant/applicant-advance-certificate'], {
						queryParams: {
							tab: this.status,
							userName: certificate.userName,
							batchType: certificate.batchType.name,
							certReqId: certificate.certReqId,
							qpCode: certificate.jobRoleId,
							sectorId: certificate.sector.id
						}
					});
				}
			}
		})
	}

	createFeedbackForm(certificate) {
		this.feedBackForm = this._formBuilder.group({
			feedBack: this._formBuilder.group({
				date: [new Date().toISOString()],
				qpCode: [certificate.jobRoleId],
				feedbackForTC: this._formBuilder.group({
					isTrainingCenter: [true],
					tcId: ['', Validators.required],
					tcName: ['', Validators.required],
					preCommunication: [null, Validators.required],
					qualityOfStudyMaterials: [null, Validators.required],
					qualityOfTraining: [null, Validators.required],
					qualityOfTools: [null, Validators.required],
					postCommunication: [null, Validators.required],
				}),
				feedbackForMT: this._formBuilder.group({
					isMasterTrainer: [true],
					masterTrainerId: ['', Validators.required],
					masterTrainerName: ['', Validators.required],
					knowledge: [null, Validators.required],
					sessions: [null, Validators.required],
					presentation: [null, Validators.required],
					exampleUsage: [null, Validators.required],
					interactive: [null, Validators.required],
					curriculum: [null, Validators.required],
				}),
				feedbackForMTTraining: this._formBuilder.group({
					learningExtent: [null, Validators.required],
					learningEnvironment: [null, Validators.required],
				}),
				feedbackForAssessor: this._formBuilder.group({
					isAssessor: [true],
					assessorId: ['', Validators.required],
					assessorName: ['', Validators.required],
					preAssessment: [null, Validators.required],
					conduct: [null, Validators.required],
					assessmentExperience: [null, Validators.required],
				}),
				recommendation: [null, Validators.required],
				overAllRating: [null, Validators.required],
				overAllComment: [null, Validators.required],
			}),
		})
		this.checkFormValidity(certificate)
	}

	checkFormValidity(certificate) {
		if (certificate.batchMode === 'Online') {
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('tcId').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('tcId').updateValueAndValidity();
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('tcName').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('tcName').updateValueAndValidity();
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('preCommunication').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('preCommunication').updateValueAndValidity();
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('qualityOfStudyMaterials').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('qualityOfStudyMaterials').updateValueAndValidity();
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('qualityOfTraining').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('qualityOfTraining').updateValueAndValidity();
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('qualityOfTools').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('qualityOfTools').updateValueAndValidity();
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('postCommunication').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('postCommunication').updateValueAndValidity();
		}
		if (certificate.batchType.type === 'TOAEXISTING' || certificate.batchType.type === 'TOTEXISTING') {
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('masterTrainerId').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('masterTrainerId').updateValueAndValidity();
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('masterTrainerName').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('masterTrainerName').updateValueAndValidity();

			this.feedBackForm.get('feedBack').get('feedbackForMT').get('knowledge').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('knowledge').updateValueAndValidity();
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('sessions').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('sessions').updateValueAndValidity();
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('presentation').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('presentation').updateValueAndValidity();
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('exampleUsage').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('exampleUsage').updateValueAndValidity();
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('interactive').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('interactive').updateValueAndValidity();
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('curriculum').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('curriculum').updateValueAndValidity();

			this.feedBackForm.get('feedBack').get('feedbackForMTTraining').get('learningExtent').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForMTTraining').get('learningExtent').updateValueAndValidity();
			this.feedBackForm.get('feedBack').get('feedbackForMTTraining').get('learningEnvironment').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForMTTraining').get('learningEnvironment').updateValueAndValidity();
		}
	}

	provideFeedback(certificate) {
		this.selectedCertificate = certificate;
		console.log(this.certificateFeedback);
		if (this.certificateFeedback) {
			toastr.error('Feedback Already Provided');
		} else {
			// Helpers.openModal('provide_feedback_modal');
			this.isFeedback = true;
			this.createFeedbackForm(certificate);
		}
	}

	createSearchTrainingCentreForm() {
		this.trainingCentreSearchForm = this._formBuilder.group({
			state: [[]],
			district: [[]],
			trainingCentreId: [''],
			trainingCentreName: [''],
			trainingCentreType: [[]]
		});
	}

	createMasterTrainerSearchForm() {
		this.masterTrainerSearchForm = this._formBuilder.group({
			state: [[]],
			district: [[]],
			mtId: [''],
			mtName: ['']
		});
	}

	createAssessorSearchForm() {
		this.assessorSearchForm = this._formBuilder.group({
			state: [[]],
			district: [[]],
			assessorId: [''],
			assessorName: ['']
		});
	}

	searchTrainer() {
		Helpers.openModal('assign_master_trainer');
		$('#provide_feedback_modal').css(
			{
				'opacity': 0.5,
				'overflow-y': 'auto'
			}
		);
		this.getTrainers();
	}

	searchAssessor() {
		Helpers.openModal('assign_assessor');
		$('#provide_feedback_modal').css(
			{
				'opacity': 0.5,
				'overflow-y': 'auto'
			}
		);
		this.getAssessors();
	}

	addTrainerFilters() {
		const data = {
			state: this.selState,
			district: this.selDistrict,
			mtId: this.masterTrainerSearchForm.get('mtId').value,
			mtName: this.masterTrainerSearchForm.get('mtName').value,
		}
		this.getTrainers(data);
	}

	addAssessorFilters() {
		const data = {
			state: this.selState,
			district: this.selDistrict,
			id: this.assessorSearchForm.get('assessorId').value,
			name: this.assessorSearchForm.get('assessorName').value,
		}
		this.getAssessors(data);
	}

	getTrainers(data?) {
		const trainerData = {
			state: {
				name: this.selState ? this.selState.name : '',
				id: this.selState ? this.selState.code : null
			},
			district: {
				name: this.selDistrict ? this.selDistrict.name : '',
				id: this.selDistrict ? this.selDistrict.code : null
			},
			mtId: data ? data.mtId : '',
			mtName: data ? data.mtName : ''
		}
		Helpers.openModal('assign_master_trainer');
		this.masterTrainerService.
			getMasterTrainerBasedonLocation(trainerData.state.id, trainerData.district.id,
				'', '', this.selectedCertificate.jobRoleId, this.filterPageNo, this.filterPerPage,
				this.selectedCertificate.batchType.name, trainerData.mtName, trainerData.mtId).subscribe((t) => {
					if (_.isNil(t.data)) {
						toastr.error('No Master Trainer found')
						this.masterTrainers = [];
						return
					}
					this.masterTrainers = t.data
					this.trainerLength = t.count
				}, (err) => {
					this.masterTrainers = [];
					toastr.error('No Master Trainer found')
				})
	}

	getAssessors(data?) {
		this.assesmentAgencyService.getAssessorsBasedOnQpCode(
			this.selectedCertificate.jobRoleId,
			this.assessorType, this.filterPageNo,
			this.filterPerPage, this.selectedCertificate.batchType.name, data)
			.subscribe(res => {
				console.log('resssss', res)
				if (res.data !== null) {
					this.assessors = res.data
					this.assessorLength = res.count;
				} else {
					toastr.error('No Assessors found');
					this.assessors = [];
					return
				}
			});
	}

	checkTrainerValidity(event) {
		if (event.target.checked) {
			this.isTrainer = false;
			this.selectedTrainer = [];
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('isMasterTrainer').setValue(false);
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('masterTrainerId').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('masterTrainerId').updateValueAndValidity();
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('masterTrainerName').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('masterTrainerName').updateValueAndValidity();
		} else {
			this.isTrainer = true;
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('isMasterTrainer').setValue(true);
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('masterTrainerId').setValidators([Validators.required]);
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('masterTrainerId').updateValueAndValidity();
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('masterTrainerName').setValidators([Validators.required]);
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('masterTrainerName').updateValueAndValidity();
		}
	}

	checkAssessorValidity(event) {
		if (event.target.checked) {
			this.isAssessor = false;
			this.selectedAssessor = [];
			this.feedBackForm.get('feedBack').get('feedbackForAssessor').get('isAssessor').setValue(false);
			this.feedBackForm.get('feedBack').get('feedbackForAssessor').get('assessorId').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForAssessor').get('assessorId').updateValueAndValidity();
			this.feedBackForm.get('feedBack').get('feedbackForAssessor').get('assessorName').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForAssessor').get('assessorName').updateValueAndValidity();
		} else {
			this.isAssessor = true;
			this.feedBackForm.get('feedBack').get('feedbackForAssessor').get('isAssessor').setValue(true);
			this.feedBackForm.get('feedBack').get('feedbackForAssessor').get('assessorId').setValidators([Validators.required]);
			this.feedBackForm.get('feedBack').get('feedbackForAssessor').get('assessorId').updateValueAndValidity();
			this.feedBackForm.get('feedBack').get('feedbackForAssessor').get('assessorName').setValidators([Validators.required]);
			this.feedBackForm.get('feedBack').get('feedbackForAssessor').get('assessorName').updateValueAndValidity();
		}
	}

	selectedAssessorIndex(assessor, index) {
		if (assessor === undefined) {
			this.assessorIndex = true;
		} else {
			this.assessorIndex = false;
			this.selectedAssessor = assessor;
			console.log(assessor, index);
		}
	}

	selectedTrainerIndex(trainer, index) {
		if (trainer === undefined) {
			this.trainerIndex = true;
		} else {
			this.trainerIndex = false;
			this.selectedTrainer = trainer;
			console.log(trainer, index);
		}
	}

	assignedAssessor() {
		if (this.selectedAssessor) {
			this.feedBackForm.get('feedBack').get('feedbackForAssessor').get('assessorId').setValue(this.selectedAssessor.userName);
			this.feedBackForm.get('feedBack').get('feedbackForAssessor').get('assessorName').setValue(this.selectedAssessor.name);
			Helpers.closeModal('assign_assessor');
			$('#provide_feedback_modal').css({
				'opacity': 1.0,
				'overflow-y': 'auto'
			});
			this.resetAssessorFilter();
		} else {
			toastr.error('Please select atleast a assessor');
		}
	}

	assignedTrainer() {
		if (this.selectedTrainer) {
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('masterTrainerId').setValue(this.selectedTrainer.userName);
			this.feedBackForm.get('feedBack').get('feedbackForMT').get('masterTrainerName').setValue(this.selectedTrainer.name);
			Helpers.closeModal('assign_master_trainer');
			$('#provide_feedback_modal').css({
				'opacity': 1.0,
				'overflow-y': 'auto'
			});
			this.resetTrainerFilter();
		} else {
			toastr.error('Please select atleast a trainer');
		}
	}

	getStates() {
		this.geographiesService.getStates()
			.subscribe(states => {
				this.states = states.states;
				this.stateDropDownData = this.states.map((state, index) => {
					return {
						id: index,
						itemName: state.name
					};
				});
			}, err => {
				console.error('Error in fetching states : ', err);
			});
	}

	getDistricts(stateId) {
		this.geographiesService.getDistricts(stateId).subscribe((districts) => {
			this.districts = districts.districts;
			this.districtDropDownData = this.districts.map((district, index) => {
				return {
					id: index,
					itemName: district.name
				};
			});
		});
	}

	onStateSelect(item: any) {
		this.selDistrict = null;
		this.stateStatus = true;
		this.pageNo = 1;
		this.selState = _.find(this.states, { name: item.itemName });
		this.getDistricts(this.selState.code);
	}

	onDistrictSelect(item: any) {
		this.districtStatus = true;
		this.selDistrict = _.find(this.districts, { name: item.itemName });
	}

	stateClick() {
		this.selState = null;
		this.selDistrict = null;
		this.getStates()
		this.stateStatus = false;
		this.districtStatus = false;
		if (!this.stateStatus) {
			this.selectedItemsDistrict = [];
			this.districtDropDownData = []
			this.selectedItemsState = []

		}
	}

	districtClick() {
		this.districtStatus = false;
		if (!this.districtStatus && !this.stateStatus) {
			this.selectedItemsState = [];
			this.selectedItemsDistrict = [];
			toastr.error('Please select state first');
		}
	}

	resetAssessorFilter(reset?) {
		if (!reset) {
			$('#provide_feedback_modal').css({
				'opacity': 1.0,
				'overflow-y': 'auto'
			});
		}
		this.filterPageNo = 1;
		this.filterPerPage = 10;
		this.assessorLength = 0
		this.selState = null;
		this.selDistrict = null;
		this.stateDropDownData = [];
		this.districtDropDownData = [];
		this.selectedItemsDistrict = [];
		this.selectedItemsState = [];
		this.assessorSearchForm.get('state').setValue(null);
		this.assessorSearchForm.get('district').setValue(null);
		this.assessorSearchForm.get('assessorId').setValue('');
		this.assessorSearchForm.get('assessorName').setValue('');
		this.getAssessors();
	}

	resetTrainerFilter(reset?) {
		if (!reset) {
			$('#provide_feedback_modal').css({
				'opacity': 1.0,
				'overflow-y': 'auto'
			});
		}
		this.filterPageNo = 1;
		this.filterPerPage = 10;
		this.trainerLength = 0;
		this.selState = null;
		this.selDistrict = null;
		this.stateDropDownData = [];
		this.districtDropDownData = [];
		this.selectedItemsDistrict = [];
		this.selectedItemsState = [];
		this.masterTrainerSearchForm.get('state').setValue(null);
		this.masterTrainerSearchForm.get('district').setValue(null);
		this.masterTrainerSearchForm.get('mtId').setValue('');
		this.masterTrainerSearchForm.get('mtName').setValue('');
		this.getTrainers();
	}

	resetTrainingCentreFilter(reset?) {
		if (!reset) {
			$('#provide_feedback_modal').css({
				'opacity': 1.0,
				'overflow-y': 'auto'
			});
		}
		this.pageNoTab_1 = 1
		this.pageNoTab_2 = 1
		this.itemsPerPageTab_1 = 10
		this.itemsPerPageTab_2 = 10
		this.lengthTab_1 = 0;
		this.lengthTab_2 = 0;
		this.tcId = ''
		this.allTcTab = true
		this.previouslyConductedTcTab = false
		this.trainingCentres = []
		this.previouslyConductedTrainingCentres = []
		this.selectedItemsState = []
		this.selectedItemsDistrict = []
		this.selState = null;
		this.selDistrict = null;
		this.stateDropDownData = [];
		this.districtDropDownData = [];
		this.selectedItemsDistrict = [];
		this.selectedItemsState = [];
		this.trainingCentreSearchForm.get('state').setValue(null);
		this.trainingCentreSearchForm.get('district').setValue(null);
		this.trainingCentreSearchForm.get('trainingCentreId').setValue('');
		this.trainingCentreSearchForm.get('trainingCentreName').setValue('');
		this.trainingCentreSearchForm.get('trainingCentreType').setValue('');
		if (this.allTcTab) {
			this.getTrainingCentres();
		} else if (this.previouslyConductedTcTab) {
			this.getPreviouslyConductedTc();
		}
	}

	checkTCValidity(event) {
		if (event.target.checked) {
			this.isTrainingCenter = false;
			this.trainingCentres = [];
			this.previouslyConductedTrainingCentres = [];
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('isTrainingCenter').setValue(false);
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('tcId').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('tcId').updateValueAndValidity();
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('tcName').setValidators([]);
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('tcName').updateValueAndValidity();
		} else {
			this.isTrainingCenter = true;
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('isTrainingCenter').setValue(true);
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('tcId').setValidators([Validators.required]);
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('tcId').updateValueAndValidity();
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('tcName').setValidators([Validators.required]);
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('tcName').updateValueAndValidity();
		}
	}

	searchTC() {
		Helpers.openModal('assign_tc');
		$('#provide_feedback_modal').css(
			{
				'opacity': 0.5,
				'overflow-y': 'auto'
			}
		);
		this.tc_tab();
	}

	tc_tab() {
		this.allTcTab = true
		this.previouslyConductedTcTab = false
		if (!this.trainingCentreSearchForm.valid) {
			toastr.error('Please select Mandatory fields')
			this.trainingCentres = []
			return
		}
		const b: any = {
			location: {
				state: {
					name: this.selState ? this.selState.name : '',
					id: this.selState ? this.selState.code : 0,
				},
				district: {
					name: this.selDistrict ? this.selDistrict.name : '',
					id: this.selDistrict ? this.selDistrict.code : 0
				},

			},
			tcName: this.trainingCentreSearchForm.get('trainingCentreName').value,
			trainingCenterName: this.trainingCentreSearchForm.get('trainingCentreId').value,
			type: this.trainingCentreSearchForm.get('trainingCentreType').value
		};
		this.getTrainingCentres(b);
	}

	previouslyConductedTc_tab() {
		this.pageNoTab_1 = 1
		this.pageNoTab_2 = 1
		this.itemsPerPageTab_1 = 10
		this.itemsPerPageTab_2 = 10
		this.previouslyConductedTcTab = true
		this.allTcTab = false
		if (!this.trainingCentreSearchForm.valid) {
			toastr.error('Please select Mandatory fields')
			this.previouslyConductedTrainingCentres = []
			return
		}
		const payload: any = {
			state: this.selState ? this.selState.code : 0,
			district: this.selDistrict ? this.selDistrict.code : 0
		};
		payload.tcName = this.trainingCentreSearchForm.get('trainingCentreName').value ? this.trainingCentreSearchForm.get('trainingCentreName').value : '';
		payload.userName = this.trainingCentreSearchForm.get('trainingCentreId').value ? this.trainingCentreSearchForm.get('trainingCentreId').value : '';
		payload['type'] = this.trainingCentreSearchForm.get('trainingCentreType').value && this.trainingCentreSearchForm.get('trainingCentreType').value.length  ? this.trainingCentreSearchForm.get('trainingCentreType').value : null;
		this.getPreviouslyConductedTc(payload);
	}

	getTrainingCentres(searchCriteria?) {
		this.trainingCentreAPI.searchTrainingCenters(searchCriteria, this.pageNoTab_1, this.itemsPerPageTab_1).subscribe((tc) => {
			this.trainingCentres = tc.data;
			this.lengthTab_1 = tc.count;
			if (_.isNil(this.trainingCentres)) {
				toastr.error('Training centre not found');
				this.trainingCentres = []
				return;
			} else {
				try {
					this.previouslyConductedTrainingCentres = []
					this.trainingCentres = this.trainingCentres.map((centre) => {
						return {
							trainingCentreName: centre.trainingCentreName,
							trainingCentreId: centre.userName,
							rating: centre.rating ? centre.rating : 'NA',
							state: centre.address.state.name,
							district: centre.address.district.name,
							address: centre.address,
							spoc: centre.spoc,
							exceptionalTC: centre.exceptionalTC ? centre.exceptionalTC : false
						};
					});
				} catch (e) {
					console.error(e);
					toastr.error('Error in Parsing Tc response');
				}
			}
		}, (err) => {
			this.trainingCentres = []
		});
	}

	getPreviouslyConductedTc(payload?) {
		this.trainingCentreAPI.getPreviouslyConductedTrainingCentres(payload.state, payload.district, payload.userName, payload.type, this.pageNoTab_2, this.itemsPerPageTab_2).subscribe((p) => {
			if (p) {
				this.previouslyConductedTrainingCentres = p.data;
				console.log(this.previouslyConductedTrainingCentres);
				this.lengthTab_2 = p.count
				if (_.isNil(this.previouslyConductedTrainingCentres)) {
					toastr.error('TOT /TOA Conducted Centres Not Found');
					this.previouslyConductedTrainingCentres = []
					return;
				} else {
					try {
						this.trainingCentres = []
						this.previouslyConductedTrainingCentres = this.previouslyConductedTrainingCentres.map((centre) => {
							return {
								trainingCentreName: centre.trainingCentreName,
								trainingCentreId: centre.userName,
								rating: centre.rating ? centre.rating : 'NA',
								trainingPartnerName: centre.trainingPartner.name,
								state: centre.address.state.name,
								district: centre.address.district.name,
								address: centre.address
							};
						});
					} catch (e) {
						console.error(e);
						toastr.error('Error in Parsing Tc response');
					}
				}
			} else {
				toastr.error('no training centre available');
			}

		}, (err) => {
			this.previouslyConductedTrainingCentres = []

		});
	}

	tab_1(tc, index) {
		if (tc === undefined) {
			this.tcIndex = true;
		} else {
			this.tcIndex = false;
			this.selectedTC = tc;
			console.log(tc, index);
		}
	}

	tab_2(tc, index) {
		if (tc === undefined) {
			this.tcIndex = true;
		} else {
			this.tcIndex = false;
			this.selectedTC = tc;
			console.log(tc, index);
		}
	}

	assignedTc() {
		if (this.selectedTC) {
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('tcId').setValue(this.selectedTC.trainingCentreId);
			this.feedBackForm.get('feedBack').get('feedbackForTC').get('tcName').setValue(this.selectedTC.trainingCentreName);
			Helpers.closeModal('assign_tc');
			$('#provide_feedback_modal').css({
				'opacity': 1.0,
				'overflow-y': 'auto'
			});
			this.resetTrainingCentreFilter();
		} else {
			toastr.error('Please select atleast a trainer');
		}
	}

	assignPageNoMT(pageNo) {
		this.filterPageNo = pageNo;
		this.getTrainers();
	}
	assignRecordsPerPageMT(perPage) {
		this.filterPerPage = perPage;
		this.getTrainers();
	}

	assignPageNoAssessor(pageNo) {
		this.filterPageNo = pageNo;
		this.getAssessors()

	}
	assignRecordsPerPageAssessor(perPage) {
		this.filterPerPage = perPage;
		this.getAssessors()
	}

	assignPageNoTab_1(pageNo) {
		this.pageNoTab_1 = pageNo;
		const payload = {
			location: {
				state: {
					name: this.selState ? this.selState.name : '',
					id: this.selState ? this.selState.code : 0,
				},
				district: {
					name: this.selDistrict ? this.selDistrict.name : '',
					id: this.selDistrict ? this.selDistrict.code : 0
				},

			},
			tcName: this.trainingCentreSearchForm.get('trainingCentreName').value,
			trainingCenterName: this.trainingCentreSearchForm.get('trainingCentreId').value,
			type: this.trainingCentreSearchForm.get('trainingCentreType').value
		};
		this.getTrainingCentres(payload);
	}

	assignRecordsPerPageTab_1(perPage) {
		this.itemsPerPageTab_1 = perPage;
		const payload = {
			location: {
				state: {
					name: this.selState ? this.selState.name : '',
					id: this.selState ? this.selState.code : 0,
				},
				district: {
					name: this.selDistrict ? this.selDistrict.name : '',
					id: this.selDistrict ? this.selDistrict.code : 0
				},
			},
			tcName: this.trainingCentreSearchForm.get('trainingCentreName').value,
			trainingCenterName: this.trainingCentreSearchForm.get('trainingCentreId').value,
			type: this.trainingCentreSearchForm.get('trainingCentreType').value
		};
		this.getTrainingCentres(payload);
	}

	assignPageNoTab_2(pageNo) {
		this.pageNoTab_2 = pageNo;
		const payload: any = {
			state: this.selState.code,
			district: this.selDistrict.code,
			tcName: this.trainingCentreSearchForm.get('trainingCentreName').value,
			userName: this.trainingCentreSearchForm.get('trainingCentreId').value,
			type: this.trainingCentreSearchForm.get('trainingCentreType').value
		};
		this.getPreviouslyConductedTc(payload);
	}

	assignRecordsPerPageTab_2(perPage) {
		this.itemsPerPageTab_2 = perPage;
		const payload: any = {
			state: this.selState.code,
			district: this.selDistrict.code,
			tcName: this.trainingCentreSearchForm.get('trainingCentreName').value,
			userName: this.trainingCentreSearchForm.get('trainingCentreId').value,
			type: this.trainingCentreSearchForm.get('trainingCentreType').value
		};
		this.getPreviouslyConductedTc(payload);
	}


	feedbackSubmitted() {
		console.log(this.feedBackForm.getRawValue);
		console.log('Feed Back', this.feedBackForm);
		const feedBack = this.feedBackForm.value.feedBack;
		feedBack.feedbackForTC = {
			isTrainingCenter: feedBack.feedbackForTC.isTrainingCenter,
			tcId: feedBack.feedbackForTC.tcId,
			tcName: feedBack.feedbackForTC.tcName,
			preCommunication: Number(feedBack.feedbackForTC.preCommunication),
			qualityOfStudyMaterials: Number(feedBack.feedbackForTC.qualityOfStudyMaterials),
			qualityOfTraining: Number(feedBack.feedbackForTC.qualityOfTraining),
			qualityOfTools: Number(feedBack.feedbackForTC.qualityOfTools),
			postCommunication: Number(feedBack.feedbackForTC.postCommunication)
		}

		feedBack.feedbackForMT = [{
			isMasterTrainer: feedBack.feedbackForMT.isMasterTrainer,
			userName: feedBack.feedbackForMT.masterTrainerId,
			name: feedBack.feedbackForMT.masterTrainerName,
			knowledge: Number(feedBack.feedbackForMT.knowledge),
			sessions: Number(feedBack.feedbackForMT.sessions),
			presentation: Number(feedBack.feedbackForMT.presentation),
			exampleUsage: Number(feedBack.feedbackForMT.exampleUsage),
			interactive: Number(feedBack.feedbackForMT.interactive),
			curriculum: Number(feedBack.feedbackForMT.curriculum)
		}]
		feedBack.feedbackForMTTraining = {
			learningExtent: Number(feedBack.feedbackForMTTraining.learningExtent),
			learningEnvironment: Number(feedBack.feedbackForMTTraining.learningEnvironment)
		}
		feedBack.feedbackForAssessor = [{
			isAssessor: feedBack.feedbackForAssessor.isAssessor,
			userName: feedBack.feedbackForAssessor.assessorId,
			name: feedBack.feedbackForAssessor.assessorName,
			preAssessment: Number(feedBack.feedbackForAssessor.preAssessment),
			conduct: Number(feedBack.feedbackForAssessor.conduct),
			assessmentExperience: Number(feedBack.feedbackForAssessor.assessmentExperience)
		}]

		feedBack.overAllRating = Number(feedBack.overAllRating)

		this._batchService.postFeedBackForCertificate(feedBack, this.selectedCertificate.certReqId).subscribe(res => {
			swal(
				'Feedback Submitted Successfully', 'Your feedback for the training has been successfully submitted', 'success'
			);
			this.cancelFeedbackForm();
			this.getCerificateList('Approved');
		});
	}

	cancelFeedbackForm() {
		this.isTrainer = true;
		this.isAssessor = true;
		this.isTrainingCenter = true;
		this.isFeedback = false;
		this.feedBackForm.reset();
		this.selectedTC = null;
		this.selectedTrainer = null;
		this.selectedAssessor = null;
		this.isTrainerFeedback = false;
		this.isFeedbackForAssessor = false;
		this.isTCFeedback = false;
		this.isFeedbackAvailable = false;
	}

	viewFeedback(certificate) {
		this.isFeedbackAvailable = true
		this.selectedCertificate = certificate;
		this.feedbackProvided = certificate.certificateDetails.feedback;
		this.isTrainerFeedback = false;
		this.isFeedbackForAssessor = false;
		this.isTCFeedback = false;
		if (this.feedbackProvided.feedbackForMT.length > 0) {
			this.isTrainerFeedback = true;
		}
		if (this.feedbackProvided.feedbackForAssessor.length > 0) {
			this.isFeedbackForAssessor = true;
		}
		if (!_.isEmpty(this.feedbackProvided.feedbackForTC)) {
			this.isTCFeedback = true
		}

		console.log(this.isTrainerFeedback, this.isFeedbackForAssessor, this.isTCFeedback);
		this.feedBackForm = this._formBuilder.group({
			feedBack: this._formBuilder.group({
				date: [this.feedbackProvided.date],
				feedbackForTC: this._formBuilder.group({
					preCommunication: [this.isTCFeedback ? { value: String(this.feedbackProvided.feedbackForTC.preCommunication), disabled: true } : { value: '', disabled: true }],
					qualityOfStudyMaterials: [this.isTCFeedback ? { value: String(this.feedbackProvided.feedbackForTC.qualityOfStudyMaterials), disabled: true } : { value: '', disabled: true }],
					qualityOfTraining: [this.isTCFeedback ? { value: String(this.feedbackProvided.feedbackForTC.qualityOfTraining), disabled: true } : { value: '', disabled: true }],
					qualityOfTools: [this.isTCFeedback ? { value: String(this.feedbackProvided.feedbackForTC.qualityOfTools), disabled: true } : { value: '', disabled: true }],
					postCommunication: [this.isTCFeedback ? { value: String(this.feedbackProvided.feedbackForTC.postCommunication), disabled: true } : { value: '', disabled: true }],
				}),
				feedbackForMT: this._formBuilder.group({
					knowledge: [this.isTrainerFeedback ? { value: String(this.feedbackProvided.feedbackForMT[0].knowledge), disabled: true } : { value: '', disabled: true }],
					sessions: [this.isTrainerFeedback ? { value: String(this.feedbackProvided.feedbackForMT[0].sessions), disabled: true } : { value: '', disabled: true }],
					presentation: [this.isTrainerFeedback ? { value: String(this.feedbackProvided.feedbackForMT[0].presentation), disabled: true } : { value: '', disabled: true }],
					exampleUsage: [this.isTrainerFeedback ? { value: String(this.feedbackProvided.feedbackForMT[0].exampleUsage), disabled: true } : { value: '', disabled: true }],
					interactive: [this.isTrainerFeedback ? { value: String(this.feedbackProvided.feedbackForMT[0].interactive), disabled: true } : { value: '', disabled: true }],
					curriculum: [this.isTrainerFeedback ? { value: String(this.feedbackProvided.feedbackForMT[0].curriculum), disabled: true } : { value: '', disabled: true }],
				}),
				feedbackForMTTraining: this._formBuilder.group({
					learningExtent: [this.isTrainerFeedback ? { value: String(this.feedbackProvided.feedbackForMTTraining.learningExtent), disabled: true } : { value: '', disabled: true }],
					learningEnvironment: [this.isTrainerFeedback ? { value: String(this.feedbackProvided.feedbackForMTTraining.learningEnvironment), disabled: true } : { value: '', disabled: true }],
				}),
				feedbackForAssessor: this._formBuilder.group({
					preAssessment: [this.isFeedbackForAssessor ? { value: String(this.feedbackProvided.feedbackForAssessor[0].preAssessment), disabled: true } : { value: '', disabled: true }],
					conduct: [this.isFeedbackForAssessor ? { value: String(this.feedbackProvided.feedbackForAssessor[0].conduct), disabled: true } : { value: '', disabled: true }],
					assessmentExperience: [this.isFeedbackForAssessor ? { value: String(this.feedbackProvided.feedbackForAssessor[0].assessmentExperience), disabled: true } : { value: '', disabled: true }],
				}),
				recommendation: [{ value: this.feedbackProvided.recommendation, disabled: true }],
				overAllRating: [this.feedbackProvided.overAllRating ? { value: String(this.feedbackProvided.overAllRating), disabled: true } : { value: '', disabled: true }],
				overAllComment: [{ value: this.feedbackProvided.overAllComment, disabled: true }],

			}),
		})

		// Helpers.openModal('view_feedback_modal');
	}
}
